import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../authentication/firebase-config";

/**
 * useStrategyAutomationFlag — feature gate for the Strategy Automation tab.
 *
 * Default OFF. The tab stays invisible to the 355 live members until an admin
 * flips strategyAutomationConfig/featureFlags.strategyAutomationTabEnabled to
 * true in the Firebase Console. Any read error fails safe to OFF.
 *
 * Local preview override (never set in production builds):
 *   REACT_APP_STRATEGY_AUTOMATION_ENABLED=true npm start
 *
 * Mirrors the signalsConfig / researchConfig flag patterns.
 */
export default function useStrategyAutomationFlag() {
  const envOn = process.env.REACT_APP_STRATEGY_AUTOMATION_ENABLED === "true";
  const [state, setState] = useState(envOn ? "on" : "loading");

  useEffect(() => {
    if (envOn) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const snap = await getDoc(doc(db, "strategyAutomationConfig", "featureFlags"));
        const on = snap.exists() && snap.data()?.strategyAutomationTabEnabled === true;
        if (!cancelled) setState(on ? "on" : "off");
      } catch {
        if (!cancelled) setState("off");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [envOn]);

  return { enabled: state === "on", loading: state === "loading" };
}
